import NotificationCard from "../notification/NotificationCard";
import NoNotifications from "../ui/NoNotifications";
import Loading from "../layout/Loading";

const NotificationsPage = ({
  data = [],
  isLoading,
  handleClearNotification,
}) => {
  const renderNotifications = () => {
    return data?.map((notification) => {
      return (
        <NotificationCard
          key={notification.notification_id}
          data={notification}
          handleClear={handleClearNotification}
        />
      );
    });
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="notifications-page-container">
      {data.length > 0 ? (
        <div className="notifications-wrapper">{renderNotifications()}</div>
      ) : (
        <NoNotifications />
      )}
    </div>
  );
};

export default NotificationsPage;
